export const dashboardPagesMenu = {
	dashboard: {
		id: 'dashboard',
		text: 'Dashboard',
		path: '/',
		icon: 'Dashboard',
		subMenu: null,
	},
};

export const masterPagesMenu = {
	master: {
		id: 'master',
		text: 'Master',
		path: 'master',
		icon: 'Apps',
		subMenu: {
			branchList: {
				id: 'branchList',
				text: 'Branch List',
				path: 'branch/branch-list',
				icon: 'House',
			},
			sectionList: {
				id: 'sectionList',
				text: 'Section List',
				path: 'branch/section-list',
				icon: 'HotelClass',
			},
			employeeList: {
				id: 'employeeList',
				text: 'Employee List',
				path: 'employee/employee-list',
				icon: 'People',
			},
			transferList: {
				id: 'transferScreen',
				text: 'Transfer Screen',
				path: 'employee/transfer-screen',
				icon: 'TransferWithinAStation',
			},
			webCheckIn: {
				id: 'webCheckIn',
				text: 'Web Check In',
				path: 'web-checkin',
				icon: 'CheckCircle',
			},
			leaveReasonMaster: {
				id: 'leaveReasonMaster',
				text: 'Leave Reason Master',
				path: 'employee/leave-reason-master',
				icon: 'Vibration',
			},
			visitorPass: {
				id: 'visitorPass',
				text: 'Visitor Pass',
				path: 'visitor/visitor-pass',
				icon: 'PersonAdd',
			},
			leaveRestriction: {
				id: 'leaveRestriction',
				text: 'Leave Restriction',
				path: 'master/leave-restriction',
				icon: 'Block',
			},
			applyLeaveAdmin: {
				id: 'applyLeaveAdmin',
				text: 'Apply Leave - Admin',
				path: 'master/apply-leave-admin',
				icon: 'Event',
			},
			leaveAdjustment: {
				id: 'leaveAdjustment',
				text: 'Leave Adjustment',
				path: 'master/leave-adjustment',
				icon: 'Edit',
			},
			requestCompOffAdmin: {
				id: 'requestCompOffAdmin',
				text: 'Request Comp Off - Admin',
				path: 'master/request-compoff-admin',
				icon: 'EventAvailable',
			},
		},
	},
};
export const superAdminMenu = {
	master: {
		id: 'superadmin',
		text: 'Super Master',
		path: 'master',
		icon: 'AirlineSeatReclineExtra',
		subMenu: {
			organisationList: {
				id: 'organisation',
				text: 'Organisation',
				path: 'master/organisation',
				icon: 'Business',
			},
		},
	},
};
export const reportsMenu = {
	Reports: {
		id: 'Reports',
		text: 'Reports',
		path: 'reports',
		icon: 'DocumentScanner',
		subMenu: {
			AttendanceReport: {
				id: 'AttendanceReport',
				text: 'Attendance Report',
				path: 'reports/attendance-report',
				icon: 'Badge',
			},
			LeaveReport: {
				id: 'LeaveReport',
				text: 'Leave Report',
				path: 'reports/leave-report',
				icon: 'Queue',
			},
			CheckInLockedReport: {
				id: 'CheckInLockedReport',
				text: 'Check In Locked Report',
				path: 'reports/check-in-locked',
				icon: 'Lock',
			},
			ManagementLeaveReport: {
				id: 'ManagementLeaveReport',
				text: 'Management Leave Report',
				path: 'reports/management-leave',
				icon: 'AssignmentInd',
			},
			DesignationWiseLeaveReport: {
				id: 'DesignationWiseLeaveReport',
				text: 'Designation Wise Leave Report',
				path: 'reports/designation-leave',
				icon: 'GroupWork',
			},
			EmployeeLeaveReport: {
				id: 'EmployeeLeaveReport',
				text: 'Employee Leave Report',
				path: 'reports/employee-leave',
				icon: 'Person',
			},
			SectionWiseAttendanceReport: {
				id: 'SectionWiseAttendanceReport',
				text: 'Section Wise Attendance Report',
				path: 'reports/section-wise-attendance-report',
				icon: 'RecentActors',
			},
			MonthlyAttendanceSummaryReport: {
				id: 'MonthlyAttendanceSummaryReport',
				text: 'Monthly Attendance Summary Report',
				path: 'reports/monthly-attendance-summary',
				icon: 'PieChart',
			},
		MonthlyCheckoutReport: {
			id: 'MonthlyCheckoutReport',
			text: 'Monthly Checkout Report',
			path: 'reports/monthly-checkout',
			icon: 'Logout',
		},
		CompOffReport: {
			id: 'CompOffReport',
			text: 'CompOff Report',
			path: 'reports/compoff',
			icon: 'EventAvailable',
		},
		OnDutyReport: {
			id: 'OnDutyReport',
			text: 'On Duty Report',
			path: 'reports/on-duty',
			icon: 'DirectionsWalk',
		},
		FestivalAdvancesReport: {
			id: 'FestivalAdvancesReport',
			text: 'Festival Advances Report',
			path: 'reports/festival-advances',
			icon: 'CardGiftcard',
		},
		MedicalAllowanceReport: {
			id: 'MedicalAllowanceReport',
			text: 'Medical Allowance Report',
			path: 'reports/medical-allowance',
			icon: 'LocalHospital',
		},
	},
},
};
export const allowancesMenu = {
	Allowances: {
		id: 'Allowances',
		text: 'Allowances',
		path: 'allowances',
		icon: 'Deck',
		subMenu: {
			Refreshments: {
				id: 'Refreshments',
				text: 'Refreshments',
				path: 'allowances/refreshments',
				icon: 'LocalCafe',
			},
			Newspaper: {
				id: 'Newspaper',
				text: 'Newspaper',
				path: 'allowances/newspaper',
				icon: 'Article',
			},
		},
	},
};

export const stationaryMenu = {
	Stationary: {
		id: 'Stationary',
		text: 'Stationary',
		path: 'stationary',
		icon: 'Deck',
		subMenu: {
			Refreshments: {
				id: 'Refreshments',
				text: 'Refreshments',
				path: 'allowances/refreshments',
				icon: 'LocalCafe',
			},
			Newspaper: {
				id: 'Newspaper',
				text: 'Newspaper',
				path: 'allowances/newspaper',
				icon: 'Article',
			},
		},
	},
};
export const loginPages = {
	login: {
		id: 'login',
		text: 'Login',
		path: 'auth-pages/login',
		icon: 'Login',
		hide: true,
	},
	dashboard: {
		id: 'dashboard',
		text: 'Dashboard',
		path: '/',
		icon: 'Dashboard',
		hide: true,
	},
	signUp: {
		id: 'signUp',
		text: 'Sign Up',
		path: 'auth-pages/sign-up',
		icon: 'PersonAdd',
		hide: true,
	},

	page404: {
		id: 'Page404',
		text: '404 Page',
		path: 'auth-pages/404',
		icon: 'ReportGmailerrorred',
		hide: true,
	},
};
